/**
 * editorTourSteps - Schritt-Konfiguration der Editor-Coach-Tour (#757)
 *
 * Jeder Schritt verweist per `anchorId` auf ein `data-tour-id`-Attribut an einem
 * realen Bedienelement (in MainLayout gesetzt). Die Tour-Engine misst dieses
 * Element live aus und positioniert Spotlight + Popover relativ dazu — kein
 * Pixel-Hardcoding, robust gegen Layout/Touch.
 *
 * Ton: ruhig, „Du", kurze Sätze, kein Ausrufezeichen (Marken-Leitfaden).
 * Die Anker 1+2 liegen im „Garten"-Tab, 3+4 in der immer sichtbaren Tab-Leiste.
 */
export const EDITOR_TOUR_STEPS = [
  {
    anchorId: 'tour-objects',
    title: 'Was in den Garten kommt',
    body: 'Hier wählst du, was du planst: Beete, Wege, Gebäude und mehr.',
    placement: 'right',
  },
  {
    anchorId: 'tour-draw',
    title: 'Umriss zeichnen',
    body: 'Hast du etwas gewählt, erscheinen hier die passenden Werkzeuge, um seinen Umriss auf die Fläche zu zeichnen.',
    placement: 'bottom',
  },
  {
    anchorId: 'tour-plants',
    title: 'Pflanzen setzen',
    body: 'Unter Pflanzen wählst du aus dem Katalog und setzt sie in deinen Garten.',
    placement: 'bottom',
  },
  {
    // TODO(#692): Der 2D/3D-Umschalter wird auf drei Zustände erweitert
    // („Bearbeiten · Ansicht · 3D"). Wenn das landet, Titel/Text hier anpassen
    // (der Anker `tour-viewmode` bleibt, er umschließt weiterhin den Umschalter).
    anchorId: 'tour-viewmode',
    title: 'Zwischen 2D und 3D',
    body: 'Wechsle jederzeit vom Plan in die räumliche Ansicht und zurück.',
    placement: 'bottom',
  },
];

/**
 * localStorage-Schlüssel für den „schon gesehen"-Zustand.
 * Bewusst `mgr_`-Präfix (nicht `gartenplaner_`): die Tour ist eine einmalige
 * Nutzer-Einführung und soll das Anlegen eines neuen Gartens überleben — der
 * „Neuer Garten"-Reset löscht alle `gartenplaner_`-Schlüssel.
 */
export const EDITOR_TOUR_DONE_KEY = 'mgr_editor_tour_done';
